module.exports = __webpack_public_path__ + "static/img/business33.eb1ccb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business33.jpg
// module id = r6tx
// module chunks = 9